import useModal from 'hooks/useModal';
import { Node, useReactFlow } from 'reactflow';
import { getNodeId } from '../../../utils/nodeUtils';
import { FLOW_TYPE } from 'constants/flow';
import useUser from 'hooks/useUser';
import ModelClearDialog from 'components/dialogs/ModelClearDialog/ModelClearDialog';
import useTakeSnapshot from '../../../hooks/useTakeSnapshot';

const useFlowUtils = () => {
  const modal = useModal();
  const { data: userData } = useUser();
  const { takeSnapshot } = useTakeSnapshot();
  const { getViewport, setNodes, setEdges, fitView } = useReactFlow();

  const handleCreateMemo = () => {
    const viewPort = getViewport();

    const width = 200;
    const height = 120;
    const x = -(viewPort.x / viewPort.zoom) + 20;
    const y = -(viewPort.y / viewPort.zoom) + 20;

    const newNode = {
      id: getNodeId('memo'),
      position: {
        x,
        y,
      },
      style: {
        width,
        height,
      },
      type: FLOW_TYPE.NODE.MEMO_NODE,
      data: {
        memo: '더블 클릭해 메모를 작성하세요',
        size: {
          width,
          height,
          x,
          y,
        },
        name: 'memo',
      },
    } as Node;

    takeSnapshot({ projectChange: false });
    setNodes((prev) => prev.concat(newNode));
  };

  const handleFitView = () => {
    fitView();
  };

  const handleModelClear = () => {
    const handleModelClear = () => {
      takeSnapshot();
      setNodes([]);
      setEdges([]);
    };

    if (!userData?.confirm.modelClear) {
      return modal.render({
        key: 'modelClearDialog',
        modal: <ModelClearDialog onModelClear={handleModelClear} />,
      });
    }

    handleModelClear();
  };

  return {
    onCreateMemo: handleCreateMemo,
    onFitView: handleFitView,
    onModelClear: handleModelClear,
  };
};

export default useFlowUtils;
